// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-ViewWrapper-wrapper-32d2aefd","page":"src-ViewWrapper-page-af110b07","container":"src-ViewWrapper-container-fdbf8448"};